<template>
  <div v-if="slides && slides.length" class="my-12 md:my-20 gallery relative py-12">
    <CardSlider :breakpoints="breakpoints">
      <div v-for="{ image, alt, caption, id } in slides" :key="id">
        <CraftAsset
          v-if="image"
          :ratio="3 / 2"
          :asset="image[0]"
          :alt="alt"
          :autoplay="true"
          :controls="true"
          :muted="true"
          sizes="90vw sm:90vw md:90vw lg:90vw xl:90vw 2xl:90vw"
          :width="864"
          crop="fill"
          data-test-id="asset"
        />
        <div v-if="caption" class="mt-4 text-sm">{{ caption }}</div>
      </div>
    </CardSlider>
  </div>
</template>

<script>
import CardSlider from '@/components/common/CardSlider';
import CraftAsset from '@/components/common/CraftAsset.vue';

export default defineNuxtComponent({
  name: 'Gallery',
  components: {
    CardSlider,
    CraftAsset,
  },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 640,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 1024,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      ],
    };
  },
});
</script>
